import { render, staticRenderFns } from "./CreateSharedNetworkForm.vue?vue&type=template&id=f2c818dc&scoped=true&"
import script from "./CreateSharedNetworkForm.vue?vue&type=script&lang=js&"
export * from "./CreateSharedNetworkForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateSharedNetworkForm.vue?vue&type=style&index=0&id=f2c818dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c818dc",
  null
  
)

export default component.exports